export const currencyFormat = (number) => {
  return number
    .toString()
    .split("")
    .reverse()
    .join("")
    .match(/.{1,3}/g)
    .join(",")
    .split("")
    .reverse()
    .join("");
};

export const getAge = (birth) => {
    const birthDate = new Date(birth)
    const today = new Date();
    const birthYear = birthDate.getFullYear();
    const birthMonth = birthDate.getMonth();
    const currentYear = today.getFullYear();
    const currentMonth = today.getMonth();
  
    let ageYears = currentYear - birthYear;
    let ageMonths = currentMonth - birthMonth;
  
    if (ageMonths < 0) {
      ageYears--;
      ageMonths += 12;
    }
  
    return { years: ageYears, months: ageMonths };
  }
